import { restClient } from '../../client';

export type SetProviderStateInput = {
  id: string;
};

export type SetProviderStateOutput = {
  status: string;
} | {
  error: string;
};

export const setProviderRegular = restClient.createRequest<SetProviderStateInput, SetProviderStateOutput>({
  url: '/api/v1/onboarding/set_provider_regular',
  method: 'POST',
});
